import { connect } from 'react-redux';
import HeaderWidget from 'nucleus-widgets/lib/Header/HeaderWidget';
/**
 * Data wrapper for the event header widget.
 */
export default connect(function (state) {
    var translate = state.text.translate;
    return {
        header: translate(state.event.title)
    };
})(HeaderWidget);
